/* eslint-disable parog-web/no-glint-expect-error-directive */
import { service } from '@ember/service';
import type { ValidatorMap } from 'ember-changeset/types';
import type FlashMessagesService from 'ember-cli-flash/services/flash-messages';
import type { IntlService } from 'ember-intl';
import CrudJournalEventBaseComponent from 'parog-web/components/forc/abstract/crud-journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import RespiratoryRateMeasuredJournalEvent from 'parog-web/models/respiratory-rate-measured-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';

export default class RespiratoryRateEditionFormComponent extends CrudJournalEventBaseComponent<RespiratoryRateMeasuredJournalEvent> {
  static override forcDisplayName = 'Mesure de la fréquence respiratoire';
  static override fullComponentId = 'respiratory-rate/edition-form';
  static override journalEventClass = RespiratoryRateMeasuredJournalEvent;

  @service declare flashMessages: FlashMessagesService;
  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceJournalEvent;

  override get toastMessage() {
    return this.session.patient
      ? {
          message: 'Votre mesure a bien été prise en compte.',
          title: 'Fréquence respiratoire'
        }
      : super.toastMessage;
  }

  override get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  override save = async () => {
    await super.save();
    this.analytics.trackPatientMeasurement('respiratory-rate');
  };

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        {{! @glint-expect-error }}
        {{#if this.session.isPatient}}
          <p class='semeia faded-text-color'>
            Pour réaliser cette mesure, utilisez un chronomètre et comptez le
            nombre de cycles respiratoires par minute, c’est-à-dire le nombre de
            fois où vous inspirez puis expirez (un cycle = 1 inspiration + 1
            expiration).<br /><br />
            Cette mesure doit être faite au repos en position assise.<br />
            Si possible, faites-vous aider d’un proche.
          </p>
        {{/if}}

        <div class='two fields'>
          <div class='field'>
            <Form.Date
              @labelName='Date de la mesure'
              @propertyName='occurredAt'
            />
          </div>
          <div class='field'>
            <Form.NumberInput
              @labelName='Fréquence respiratoire (cycles/min)'
              @propertyName='respiratoryRate'
              @type='integer'
            />
          </div>
        </div>
        <div class='field'>
          <Form.TextArea @labelName='Commentaires' @propertyName='comments' />
        </div>
      </:content>
    </Provider>
  </template>
}
